export default {
    path: "/config",
    component: () => import("~/pages/config/index.vue"),
}